import { BoxProps } from '@jfs/ui-new'

export const style = {
  contentContainerStyle: {
    flexGrow: 1,
  },
  mainCont: {} as BoxProps,
}
